import { useRef, useState } from 'react';
import { MobileDatePicker } from '@mui/x-date-pickers';
import { gridLocalShortDate, SHORT_DATE_FORMAT } from 'utilities/dateFormats';
import { GridDateProps } from './GridDate.props';
import { HiddenTextField, StyledActionButton, StyledCalendarIcon } from './GridDate.styles';

const GridDate = ({
  cell,
  value,
  readOnly = false,
  disabled = false,
  minDate,
  maxDate,
  icon: Icon,
  onCellsChanged,
  disableFuture = false,
}: GridDateProps) => {
  const [openPicker, setOpenPicker] = useState(false);
  const [localDate, setLocalDate] = useState(value ? new Date(value) : null);
  const textFieldRef = useRef<HTMLInputElement>(null);

  const handleOpenPicker = () => {
    setOpenPicker(true);
  };

  const handleClosePicker = () => {
    setOpenPicker(false);
  };

  const handleChange = (dateParam: Date | null) => {
    if (dateParam) {
      // Update local state to allow proper navigation
      setLocalDate(dateParam);

      // Don't update cell value here - only update on final selection (onAccept).
      // This will prevent intermediate selections from triggering API calls.
    }
  };

  const handleAccept = (dateParam: Date | null) => {
    if (dateParam) {
      onCellsChanged(gridLocalShortDate(dateParam), cell);
    }
  };

  return (
    <>
      <StyledActionButton disabled={disabled} size="small" color="primary" onClick={handleOpenPicker}>
        {Icon ? <Icon size="small" color="secondary" /> : <StyledCalendarIcon fontSize="small" color="secondary" />}
      </StyledActionButton>
      <MobileDatePicker
        open={openPicker}
        onOpen={handleOpenPicker}
        onClose={handleClosePicker}
        value={localDate}
        format={SHORT_DATE_FORMAT}
        onChange={handleChange}
        onAccept={handleAccept}
        openTo={localDate ? 'day' : 'year'}
        views={['year', 'month', 'day']}
        disabled={!!readOnly}
        minDate={minDate ? new Date(minDate) : undefined}
        maxDate={maxDate ? new Date(maxDate) : undefined}
        disableFuture={disableFuture}
        slots={{
          textField: params => (
            <HiddenTextField
              {...params}
              ref={textFieldRef}
              inputProps={{
                ...params.inputProps,
                readOnly: true,
              }}
            />
          ),
        }}
      />
    </>
  );
};

export default GridDate;
